import API from '../index';
import { TaxInfo } from '../../types/common';

const getCustomerTaxInfo = async (): Promise<TaxInfo> => {
  const data: TaxInfo = await API.get(`/taxes/TW`);
  return data;
};

export default getCustomerTaxInfo;
